import * as THREE from 'three';
import type { ReferencePlane } from '../../../../../reference/ReferencePlane';
import type { LineProjectionResult } from '../../../model/ProjectionResult';
import type { ResolvedLineReferenceSource } from '../SketchReferenceSourceResolver';
import type { SupportProjectionPreprocessor } from './SupportProjectionPreprocessor';
import {
	PROJECTION_EPSILON,
	toWorldCoordinate,
} from './SupportProjectionPreprocessor';

/**
 * 线源投影预处理器。
 * 说明：
 * 1. 仅负责把来源端点正交投影到目标草图平面；
 * 2. 投影后若两端点重合，则视为退化；
 * 3. 统一输出 `ProjectionResult`，不再暴露旧的 projected payload。
 */
export class LineSupportProjectionPreprocessor
	implements SupportProjectionPreprocessor<ResolvedLineReferenceSource, LineProjectionResult>
{
	/**
	 * 执行线源投影。
	 *
	 * @param input 投影输入。
	 * @returns 成功时返回线投影结果，退化时返回 null。
	 */
	public projectToTargetPlane(input: {
		source: ResolvedLineReferenceSource;
		targetReferencePlane: ReferencePlane;
	}): LineProjectionResult | null {
		const startLocal = input.targetReferencePlane.worldToLocal(
			new THREE.Vector3(...input.source.startWorld),
		);
		const endLocal = input.targetReferencePlane.worldToLocal(
			new THREE.Vector3(...input.source.endWorld),
		);

		if (startLocal.distanceTo(endLocal) <= PROJECTION_EPSILON) {
			return null;
		}

		return {
			sourceDescriptor: input.source.sourceDescriptor,
			sourceKind: 'line',
			projectionResultKind: 'line',
			diagnostics: [],
			geometryPayload: {
				startWorld: toWorldCoordinate(input.targetReferencePlane.localToWorld(startLocal)),
				endWorld: toWorldCoordinate(input.targetReferencePlane.localToWorld(endLocal)),
			},
		};
	}
}
